import { Button, Toggle } from '@cimpress/react-components';
import React, { useState } from 'react';
import { AlignItems, FlexBox, FlexDirection, JustifyContent } from '../../utils/css-classes';
import { useWorkflows } from '../../adapters/use-workflows';
import { UseWorkflowHook, UseWorkflowLogHook, UseWorkflowsHook } from '../../ports/WorkflowService';
import { useInterval } from 'react-use';
import { Location } from '../../models/location';
import { createWorkflowSummary } from '../../components/workflows/WorkflowSummary';
import { useWorkflow } from '../../adapters/use-workflow';
import { useCurrentLocation } from '../../store/hooks/useCurrentLocation';

// tslint:disable-next-line:import-name
import style from './index.module.css';
import { useWorkflowLog } from '../../adapters/use-workflow-log';

// tslint:disable-next-line:function-name
export function createWorkflowsPage(
  {
    useCurrentLocation,
    useWorkflow,
    useWorkflowLog,
    useWorkflows,
  }: {
    useCurrentLocation: () => Location;
    useWorkflow: UseWorkflowHook;
    useWorkflowLog: UseWorkflowLogHook;
    useWorkflows: UseWorkflowsHook;
  },
) {
  // tslint:disable-next-line:variable-name
  const WorkflowSummary = createWorkflowSummary({ useWorkflow, useCurrentLocation, useWorkflowLog });

  // tslint:disable-next-line:function-name
  return function Workflows() {
    const {
      workflows,
      isLoading,
      loadMore,
      update,
    } = useWorkflows();
    const [isRefreshing, setIsRefreshing] = useState(true);
    useInterval(
      update,
      isRefreshing ? 5000 : null,
    );
    return <>
      <div className={`${FlexBox.FLEX} ${FlexDirection.ROW} ${JustifyContent.FLEX_END} ${AlignItems.CENTER}`}>
        <h6>
          Auto-refresh&nbsp;
        </h6>
        <Toggle on={isRefreshing} onClick={() => setIsRefreshing(!isRefreshing)} size="sm" />
      </div>
      <div className={`${FlexBox.FLEX} ${FlexDirection.COLUMN} ${AlignItems.CENTER} ${style.Workflows}`}>
        {(workflows ?? []).map(workflow => <WorkflowSummary key={workflow.id} workflow={workflow} />)}
        <Button type="default" disabled={isLoading && !workflows} onClick={loadMore}>Load more</Button>
      </div>
    </>;
  };
}

// tslint:disable-next-line:variable-name
export const Workflows = createWorkflowsPage({ useCurrentLocation, useWorkflow, useWorkflows, useWorkflowLog });
